// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import ChevronUp20 from './ChevronUp20';
import ChevronUp24 from './ChevronUp24';
import ChevronUp40 from './ChevronUp40';
import ChevronUp48 from './ChevronUp48';

type ChevronUpProps = {
    variation: '20' | '24' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    ChevronUp20,
    ChevronUp24,
    ChevronUp40,
    ChevronUp48,
};

const ChevronUp: FC<ChevronUpProps> = ({ variation, ...props }) => {
    const variationKey = `ChevronUp${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"ChevronUp" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default ChevronUp;
